import { useState } from "react"
import { Button, CircularProgress } from "@mui/material"
import { CheckCircleOutline, ErrorOutline } from "@mui/icons-material"

type Props = {
    onClick: () => Promise<boolean>
    onSuccess: () => void
    disabled?: boolean
    label: string
}

type Status = "idle" | "loading" | "success" | "error"

export const SaveButton = ({ onClick, onSuccess, label, disabled = false }: Props) => {
    const [status, setStatus] = useState<Status>("idle")

    const handleClick = async () => {
        if (disabled || status === "loading") return
        setStatus("loading")

        const result = await onClick()
        if (result) {
            setStatus("success")
            setTimeout(() => onSuccess(), 1000)
        } else {
            setStatus("error")
            setTimeout(() => setStatus("idle"), 1500)
        }
    }

    const renderButton = () => {
        switch (status) {
            case "loading":
                return <CircularProgress size={24} color="inherit" />
            case "success":
                return <CheckCircleOutline color="inherit" />
            case "error":
                return <ErrorOutline color="inherit" />
            default:
                return label
        }
    }

    return (
        <Button onClick={handleClick} variant="contained" disabled={disabled || status === "loading"}>
            {renderButton()}
        </Button>
    )
}
